import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { FileTabPanel } from './FileTabPanel';
import { FileStyledTabs } from './FileStyledTabs';
import { FileStyledTab } from './FileStyledTab';
import { devActions } from '../../../redux/actions';
import { FileEditorTemplate } from './FileEditorTemplate';
import { FileEditorPrimitiva } from './FileEditorPrimitiva';
import { FileEditorOrquestador } from './FileEditorOrquestador';
import { devModeConfig } from '../../components/DevMode.helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
}));

export const FileTabs = () => {
  const classes = useStyles();
  const tabs = useSelector(state => state.dev.tabs);
  const selectedTab = useSelector(state => state.dev.selectedTab);

  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    dispatch(devActions.selectTab(newValue))
    .then(() => {
      dispatch(devActions.selectNodeFile(tabs[newValue].data.id));
    });
  };

  const handleClose = (tab) => {
    dispatch(devActions.closeTab(tab));
  };

  return (
    <>
      <AppBar position="static" >
        <FileStyledTabs 
          variant="scrollable"
          value={selectedTab} 
          onChange={handleChange} 
          style={{backgroundColor: "#31322f"}}
        >
          {tabs.map(tab => (
            <FileStyledTab 
              key={"tab_" + tab.data.id} 
              type={tab.data.metadata.type} 
              label={tab.data.name} 
              changed={tab.changed} 
              onClose={() => handleClose(tab)}
              method={tab.data.metadata?.item?.metodo} 
              templateType={tab.data.metadata?.item?.tipoTemplate} 
            />
          ))}     
        </FileStyledTabs>
      </AppBar>
      {tabs.map((tab, index) => (
        <FileTabPanel key={"editor_" + tab.data.id} value={selectedTab} index={index}>
          {tab.data.metadata.type === devModeConfig.template.type && 
            <FileEditorTemplate tab={tab} index={index}/>
          }
          {tab.data.metadata.type === devModeConfig.primitiva.type && 
            <FileEditorPrimitiva tab={tab} index={index} />
          }
          {tab.data.metadata.type === devModeConfig.operacion.type && 
            <FileEditorOrquestador tab={tab} index={index} active={selectedTab === index}/>
          }
        </FileTabPanel>
      ))}     
    </>
  );
}

